import store from '@/store';

var startDate = "", endDate = "";
// 此处自定义校验手机号码js逻辑
let validatePhone = (rule, value, callback) => {
  // 清空空格
  verifyRegular("phone", removeSpace(2, value), callback);
};
// 此处自定义校验手机号码js逻辑
let validatePhoneContact = (rule, value, callback) => {
  // 清空空格
  if (value == "" || !value) {
    callback();
  } else {
    verifyRegular("phone", removeSpace(2, value), callback);
  }
};
// 商户名称校验
let validateMerchant = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("merchant", removeSpace(2, value), callback);
}
// 税单小数校验
let validatePoint = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("point", value, callback);
}
// 工商注册号校验
let validateBusiness = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("business", removeSpace(2, value), callback);
}
// 地址、城市
let validateAddress = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("address", removeSpace(1, value), callback);
}
// 联系地址,
let validateSiteCont = (rule, value, callback) => {
  if (value == "" || !value) {
    callback();
  } else {
    verifyRegular("address", removeSpace(1, value), callback);
  }
}
// 开户行校验
let validateBank = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("bank", removeSpace(1, value), callback);
};
// 年龄校验
let validateAge = (rule, value, callback) => {
  if (!value || value >= 18 && value < 100) {
    callback();
  } else {
    callback(new Error("年龄限制不能小于18，大于100"))
  }
}
// 联系人校验
let validateName = (rule, value, callback) => {
  // 调用验证方法
  if (value == "" || !value) {
    callback();
  } else {
    verifyRegular("name", value, callback);
  }
}
// 联系人邮箱校验
let validateEmail = (rule, value, callback) => {
  // 调用验证方法
  if (value == "" || !value) {
    callback();
  } else {
    verifyRegular("email", value, callback);
  }
}
// ip白名单
let validateIp = (rule, value, callback) => {
  // 清空空格
  // 调用验证方法
  if (value == "" || !value) {
    callback();
  } else {
    verifyRegular("ip", removeSpace(2, value), callback);
  }
}
// // 金额校验
// let validateMaxPay = (rule, value, callback) => {
//   if (value == "" || !value) {
//     callback(new Error("请输入金额"));
//   } else {
//     verifyRegular("number", value, callback);
//   }
// }
// 银行账户校验
let validateBankAccount = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("bankAccount", removeSpace(2, value), callback);
}
// 登录账号校验
let validateAccount = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("account", removeSpace(2, value), callback);
}
// 密码校验
let isRequired = (rule, value, callback) => {
  if (value == "") {
    callback(new Error("请输入登录密码"));
  } else {
    if (value.length == 0) {
      callback();
    }
    if (store.state.lengthPwd && store.state.iconPwd && store.state.charsPwd) {
      callback();
    } else {
      callback(new Error("密码设置不符合要求"));
    }
  }
};
// 账户校验
let accountValidat = (rule, value, callback) => {
  if (value == "") {
    callback(new Error("请选择账户"));
  } else {
    callback();
  }
}
// 法人代表校验
let validateLegalMan = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("name", removeSpace(2, value), callback);
}
// 身份证号校验
let validateCode = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("code", removeSpace(2, value), callback);
};
// 此处自定义校验手机号码js逻辑
let validateMobile = (rule, value, callback) => {
  // 清空空格
  verifyRegular("mobile", removeSpace(2, value), callback);
};
//校验结束时间
let validateStartTime = (rule, value, callback) => {
  startDate = value;
  if (!value) {
    callback(new Error("请选择代理开始时间"));
  } else {
    callback();
  }
};
let validateEndTime = (rule, value, callback) => {
  endDate = value;
  if (!value) {
    callback(new Error("请选择代理终止时间"));
  } else {
    if (!startDate) {
      callback(new Error("请选择代理开始时间"));
    } else if (
      Date.parse(startDate) >= Date.parse(value)
    ) {
      callback(new Error("结束时间必须大于开始时间！"));
    } else {
      callback();
    }
  }
};
// 此处自定义校验手机号码js逻辑
let validateBillMobile = (rule, value, callback) => {
  // 清空空格
  if (value == "" || !value) {
    callback();
  } else {
    verifyRegular("mobile", value, callback);
  }
};
// 快递单号
let validateBillNum = (rule, value, callback) => {
  // 调用验证方法
  if (value == "" || !value) {
    callback();
  } else {
    verifyRegular("business", value, callback);
  }
};
// 此处自定义校验手机号码js逻辑
let phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
let telPhone = /^0\d{2,3}-?\d{7,8}$/;
let validateTelphone = (rule, value, callback) => {
  if (!phoneReg.test(value) && !telPhone.test(value)) {
    callback(new Error("请输入正确的联系电话号码"));
  } else {
    callback();
  }
};
// 此处自定义校验任务名称
let validateTaskName = (rule, value, callback) => {
  // 调用方法
  verifyRegular("taskName", removeSpace(1, value), callback);
};
let validateTaskDes = (rule, value, callback) => {
  // 调用方法
  verifyRegular("address", removeSpace(1, value), callback);
};

export default {
  // ---------------------商户信息校验
  tenant: {
    businessId: [
      {required: true, message: "请选择客户经理", trigger: "blur"},
    ],
    name: [
      {required: true, message: "请输入商户名称", trigger: "blur"},
      {max: 100, message: "商户名称最长输入100个字符", trigger: "blur"},
      {validator: validateMerchant, message: "商户名称仅支持输入汉字、()、【】、（）、-", trigger: "blur"}
    ],
    businessCode: [
      {required: true, message: "请输入社会统一信用代码", trigger: "blur"},
      {max: 18, message: "社会统一信用代码最长输入18个字符", trigger: "blur"},
      {validator: validateBusiness, message: "社会统一信用代码格式不正确", trigger: "blur"}
    ],
    fullName: [
      {required: true, message: "请输入商户全称", trigger: "blur"},
      {max: 100, message: "商户全称最长输入100个字符", trigger: "blur"},
      {validator: validateMerchant, message: "商户全称仅支持输入汉字、()、【】、（）、-", trigger: "blur"}
    ],
    userName: [
      {required: true, message: "请输入登录账号", trigger: "blur"},
      {min: 4, message: "登录账号最少输入4个字符", trigger: "blur"},
      {max: 20, message: "登录账号最长输入20个字符", trigger: "blur"},
      {validator: validateAccount, message: "登录账号仅支持输入字母、数字、-、_", trigger: "blur"}
    ],
    industry: [
      {message: "请输入所属行业", trigger: "blur"},
    ],
    city: [
      {required: true, message: "请输入城市", trigger: "blur"},
      {max: 100, message: "城市最长输入100个字符", trigger: "blur"},
      {validator: validateAddress, message: "城市输入格式不正确", trigger: "blur"}
    ],
    businessAddress: [
      {required: true, message: "请输入注册地址", trigger: "blur"},
      {max: 100, message: "注册地址最长输入100个字符", trigger: "blur"},
      {validator: validateAddress, message: "注册地址输入格式不正确", trigger: "blur"}
    ],
    createTime: [
      {required: true, message: "请输入注册日期", trigger: "blur"},
    ],
    registerMobile: [
      {required: true, message: "请输入注册电话"},
      {validator: validatePhone, message: "请输入正确的电话号码", trigger: "blur"},
    ],
    bankName: [
      {required: true, message: "请输入开户行", trigger: "blur"},
      {max: 100, message: "开户行最长输入100个字符", trigger: "blur"},
      {validator: validateBank, message: "开户行支持输入汉字、字母、特殊字符", trigger: "blur"}
    ],
    minPay: [
      {required: true, message: "请输入单笔发放最小值", trigger: "blur"},
      {required: true, pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: "最小值只能输入两位小数", trigger: "blur"}
    ],
    bankAccount: [
      {required: true, message: "请输入银行账号", trigger: "blur"},
      {validator: validateBankAccount, message: "请输入正确的银行账号", trigger: "blur"}
    ],
    isTest: [
      {required: true, message: "请选择商户标识", trigger: "change"},
    ],
    platformId: [
      {required: true, message: "请选择平台", trigger: "change"},
    ],
    maxAge: [
      {validator: validateAge, message: "年龄限制不能小于18，大于100", trigger: "blur"},
    ],
    contactName: [
      {min: 2, message: "联系人请输入 2-20 位", trigger: "blur"},
      {max: 20, message: "联系人请输入 2-20 位", trigger: "blur"},
      {validator: validateName, message: "联系人只能输入汉字", trigger: "blur"}
    ],
    contactMobile: [
      {validator: validatePhoneContact, message: "请输入正确的电话号码", trigger: "blur"},
    ],
    contactAddress: [
      {max: 100, message: "联系地址最长输入100个字符", trigger: "blur"},
      {validator: validateSiteCont, message: "联系地址输入格式不正确", trigger: "blur"}
    ],
    contactEmail: [
      {validator: validateEmail, message: "请输入正确的邮箱", trigger: "blur"},
    ],
    adoptIp: [
      {max: 300, message: "白名单最长输入300个字符", trigger: "blur"},
      {validator: validateIp, message: "请输入正确的ip", trigger: "blur"}
    ],
    // seasonMaxPay: [
    //   { required: true, message: "请输入金额", trigger: "blur" },
    //   { validator: validateMaxPay, message: "请输入两位小数的金额", trigger: "blur" }
    // ],
    newaccount: [
      {required: true, message: "请输入登录账号", trigger: "blur"},
      {min: 4, message: "登录账号最少输入4个字符", trigger: "blur"},
      {max: 20, message: "登录账号最长输入20个字符", trigger: "blur"},
      {validator: validateAccount, message: "登录账号仅支持输入字母、数字、-、_", trigger: "blur"}
    ],
    password: [
      {validator: isRequired, trigger: "blur"}
    ],
    serviceId: [
      {required: true, message: "请选择服务商", trigger: "change"},
    ],
    notifyType: [
      {required: true, message: "请选择通知类型", trigger: "change"},
    ],
    notifyPath: [
      {required: true, message: "请输入通知地址", trigger: "blur"},
      {pattern: /^[a-zA-z]+:\/\/[^\s]*$/, message: "请输入正确的地址", trigger: "blur"}
    ],
    accountNo: [
      {required: true, validator: accountValidat, trigger: "change"},
    ]
  },
  // ---------------------服务商校验
  service: {
    userName: [
      {required: true, message: "请输入登录账号", trigger: "blur"},
      {min: 4, message: "登录账号最少输入4个字符", trigger: "blur"},
      {max: 20, message: "登录账号最长输入20个字符", trigger: "blur"},
      {validator: validateAccount, message: "登录账号仅支持输入字母、数字、-、_", trigger: "blur"}
    ],
    name: [
      {required: true, message: "请输入服务商名称", trigger: "blur"},
      {max: 100, message: '服务商名称最长输入100个字符', trigger: 'blur'},
      {validator: validateMerchant, message: '服务商名称仅支持输入汉字、字母、数字、()、【】、（）、-', trigger: 'blur'}
    ],
    fullName: [
      {required: true, message: "请输入服务商全称", trigger: "blur"},
      {max: 100, message: '服务商名称最长输入100个字符', trigger: 'blur'},
      {validator: validateMerchant, message: '服务商全称仅支持输入汉字、字母、数字、()、【】、（）、-', trigger: 'blur'}
    ],
    businessCode: [
      {required: true, message: "请输入社会统一信用代码", trigger: "blur"},
      {max: 18, message: '社会统一信用代码最长输入18个字符', trigger: 'blur'},
      {validator: validateBusiness, message: '请输入正确的社会统一信用代码', trigger: 'blur'}
    ],
    legalMan: [
      {required: true, message: "请输入法人姓名", trigger: "blur"},
      {min: 2, message: "法人姓名输入 2-20 位汉字", trigger: "blur"},
      {max: 20, message: "法人姓名输入 2-20 位汉字", trigger: "blur"},
      {validator: validateLegalMan, message: "法人姓名只能输入汉字", trigger: "blur"}
    ],
    businessAddress: [
      {required: true, message: "请输入注册地址", trigger: "blur"},
      {max: 100, message: "注册地址最长输入100个字符", trigger: "blur"},
      {validator: validateAddress, message: '注册地址支持输入汉字、数字、字母、特殊字符', trigger: 'blur'}
    ],
    registerMobile: [
      {required: true, message: "请输入注册电话", trigger: "blur"},
      {validator: validatePhone, message: "请输入正确的电话号码", trigger: "blur"},
    ],
    bankName: [
      {required: true, message: "请输入开户行", trigger: "blur"},
      {max: 100, message: "开户行最长输入100个字符", trigger: "blur"},
      {validator: validateBank, message: '开户行支持输入汉字、字母、特殊字符', trigger: 'blur'}
    ],
    bankAccount: [
      {required: true, message: "请输入银行账号", trigger: "blur"},
      {validator: validateBankAccount, message: "请输入正确的银行账号", trigger: "blur"}
    ],
    bankNumber: [
      {required: true, message: "请输入联行号", trigger: "blur"},
      {validator: validateBankAccount, message: "请输入正确的联行号", trigger: "blur"}
    ],
    contactName: [
      {required: true, message: "请输入联系人姓名", trigger: "blur"},
      {min: 2, message: "联系人请输入 2-20 位", trigger: "blur"},
      {max: 20, message: "联系人请输入 2-20 位", trigger: "blur"},
      {validator: validateLegalMan, message: "联系人只能输入汉字", trigger: "blur"}
    ],
    contactMobile: [
      {required: true, message: "请输入联系电话", trigger: "blur"},
      {validator: validatePhone, message: "请输入正确的电话号码", trigger: "blur"},
    ],
    newUserName: [
      {required: true, message: "请输入登录账号", trigger: "blur"},
      {min: 4, message: "登录账号最少输入4个字符", trigger: "blur"},
      {max: 20, message: "登录账号最长输入20个字符", trigger: "blur"},
      {validator: validateAccount, message: "登录账号仅支持输入字母、数字、-、_", trigger: "blur"}
    ],
    minMoney: [
      {required: true, message: "纳税区间最小值不能为空", trigger: "blur"},
    ],
    stepAmountPoint: [
      {required: true, message: "税率不能为空", trigger: "blur"},
    ],
    baseAmountPoint: [
      {required: true, message: "税点不能为空", trigger: "blur"},
      // {validator: validatePoint, message: '只支持输入0~1之间的小数', trigger: 'blur'}
      {
        required: true,
        pattern: /^(?:[1-9][0-9]*(\.[0-9]+)?|0\.[0-9]+)$/,
        message: "税点只能输入正整数",
        trigger: "blur"
      }
    ],
    frameCycle: [
      {required: true, message: "是否包含附加税返税不能为空", trigger: "blur"},
    ],
  },
  // ---------------------代理商校验
  agent: {
    name: [
      {required: true, message: "请输入代理商名称", trigger: "blur"},
      {max: 100, message: "代理商名称最长输入100个字符", trigger: "blur"},
      {validator: validateMerchant, message: "代理商名称支持输入汉字、()、【】、（）、-", trigger: "blur"},
    ],
    userName: [
      {required: true, message: "请输入登录账号", trigger: "blur"},
      {min: 4, message: "登录账号最少输入4个字符", trigger: "blur"},
      {max: 20, message: "登录账号最长输入20个字符", trigger: "blur"},
      {validator: validateAccount, message: "登录账号仅支持输入字母、数字、-、_", trigger: "blur"},
    ],
    legalMan: [
      {required: true, message: "请输入联系人", trigger: "blur"},
      {min: 2, message: "联系人请输入 2-20 位", trigger: "blur"},
      {max: 20, message: "联系人请输入 2-20 位", trigger: "blur"},
      {validator: validateLegalMan, message: "联系人仅支持输入汉字", trigger: "blur"},
    ],
    legalManMobile: [
      {required: true, message: "请输入手机号码", trigger: "blur"},
      {validator: validateMobile, message: "请输入正确的手机号码", trigger: "blur"},
    ],
    baseAmountPoint: [
      {required: true, message: "请输入月结数值", trigger: "blur"},
    ],
    startDate: [
      {required: true, validator: validateStartTime, trigger: "change"},
    ],
    endDate: [
      {required: true, validator: validateEndTime, trigger: "change"},
    ],
    bankName: [
      {required: true, message: "请输入开户行", trigger: "blur"},
      {max: 100, message: "开户行最长输入100个字符", trigger: "blur"},
      {validator: validateBank, message: "开户行支持输入汉字和特殊字符", trigger: "blur"},
    ],
    bankAccount: [
      {required: true, message: "请输入银行账号", trigger: "blur"},
      {validator: validateBankAccount, message: "请输入正确的银行账号", trigger: "blur"},
    ],
    agentType: [
      {required: true, message: "请选择代理商类型", trigger: "change"},
    ],
    firmName: [
      {required: true, message: "请输入公司名称", trigger: "blur"},
      {max: 100, message: "公司名称最长输入100个字符", trigger: "blur"},
      {validator: validateMerchant, message: "公司名称仅支持输入汉字、()、【】、（）、-", trigger: "blur"},
    ],
    baseTaxPoint: [
      {required: true, message: "税点不能为空", trigger: "blur"},
      // {validator: validatePoint, message: '只支持输入0~1之间的小数', trigger: 'blur'}
      {
        required: true,
        pattern: /^(?:[1-9][0-9]*(\.[0-9]+)?|0\.[0-9]+)$/,
        message: "税点只能输入正整数",
        trigger: "blur"
      }
    ],
    businessCode: [
      {required: true, message: "请输入社会统一信用代码", trigger: "blur"},
      {max: 18, message: "社会统一信用代码最长输入18个字符", trigger: "blur"},
      {validator: validateBusiness, message: "请输入正确的社会统一信用代码", trigger: "blur"},
    ],
    businessAddress: [
      {message: "请输入注册地址", trigger: "blur"},
      {max: 100, message: "注册地址最长输入100个字符", trigger: "blur"},
      {validator: validateSiteCont, message: "注册地址支持输入汉字、字母、数字、特殊字符", trigger: "blur"},
    ],
    registerMobile: [
      {message: "请输入注册电话", trigger: "blur"},
      {validator: validatePhoneContact, message: "请输入正确的电话号码", trigger: "blur"},
    ],
    lastName: [
      {required: true, message: "请输入姓名", trigger: "blur"},
      {min: 2, message: "姓名请输入 2-20 位", trigger: "blur"},
      {max: 20, message: "姓名请输入 2-20 位", trigger: "blur"},
      {validator: validateLegalMan, message: "姓名仅支持输入汉字", trigger: "blur"},
    ],
    cardCode: [
      {required: true, message: "请输入身份证号", trigger: "blur"},
      {min: 15, max: 18, message: "请如实填写18位身份证号码", trigger: "blur"},
      {validator: validateCode, message: "请输入正确的身份证号码", trigger: "blur"},
    ],
    minMoney: [
      {required: true, message: "请输入业绩目标最小值", trigger: "blur"},
    ],
    stepAmountPoint: [
      {required: true, message: "请输入业绩返点", trigger: "blur"},
    ],
    newUserName: [
      {required: true, message: "请输入登录账号", trigger: "blur"},
      {min: 4, message: "登录账号最少输入4个字符", trigger: "blur"},
      {max: 20, message: "登录账号最长输入20个字符", trigger: "blur"},
      {validator: validateAccount, message: "登录账号仅支持输入字母、数字、-、_", trigger: "blur"},
    ],
  },

  // ---------------------退款校验
  refund: {
    merchantId: [
      {required: true, message: "请选择商户名称", trigger: "blur"},
    ],
    serviceId: [
      {required: true, message: "请选择服务商名称", trigger: "blur"},
    ],
    refundType: [
      {required: true, message: "请选择退款方式", trigger: "blur"},
    ],
    refundBank: [
      {required: true, message: "请输入退款账户名称", trigger: "blur"},
      // 只允许字母、数字和汉字
      //{required: true, pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/, message: "不支持特殊字符", trigger: "blur"}
    ],
    refundBankName: [
      {required: true, message: "请输入退款账户开户行名称", trigger: "blur"},
      //{required: true, pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/, message: "不支持特殊字符", trigger: "blur"}
    ],
    refundAccount: [
      {required: true, message: "请输入退款账户银行账号", trigger: "blur"},
      // 只允许数字
      {required: true, pattern: /^[0-9]*$/, message: "退款账户账号只能是数字", trigger: "blur"}
    ],
    remark: [
      {required: true, message: "请输入退款原因", trigger: "blur"},
      {max: 50, message: "退款原因最长输入50个字符", trigger: "blur"},
      // {required: true, pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/, message: "不支持特殊字符", trigger: "blur"}
    ],
    refundAmount: [
      {required: true, message: "请输入退款金额", trigger: "blur"},
      {max: 20, message: "金额最长输入20个字符", trigger: "blur"},
      // 该正则支持输入正整数和小数,不支持输入0及负数
      {required: true, pattern: /^(?!0$)\d+(\.\d+)?$/ , message: "金额需大于等于零", trigger: "blur"}
      // {required: true, pattern: /^(?:[1-9][0-9]*(\.[0-9]+)?|0\.[0-9]+)$/, message: "金额需大于零", trigger: "blur"}

    ],
    updateInvoicedAmount: [
      {required: true, message: "请输入扣除可开票金额", trigger: "blur"},
      {max: 20, message: "金额最长输入20个字符", trigger: "blur"},
      // {required: true, pattern: /^(?:[1-9][0-9]*(\.[0-9]+)?|0\.[0-9]+)$/, message: "金额需大于零", trigger: "blur"}
      {required: true, pattern: /^(?!0$)\d+(\.\d+)?$/ , message: "金额需大于等于零", trigger: "blur"}
    ],
  },

  // ---------------------驳回
  reject: {
    reason: [
      {required: true, message: '请输入驳回原因', trigger: 'blur'},
    ],
  },

  // ---------------------个人认证校验
  personal: {
    name: [
      {required: true, message: "请输入姓名", trigger: "blur"},
      {min: 2, message: "姓名请输入 2-20 位", trigger: "blur"},
      {max: 20, message: "姓名请输入 2-20 位", trigger: "blur"},
      {validator: validateLegalMan, message: '姓名仅支持输入汉字', trigger: 'blur'}
    ],
    cardCode: [
      {required: true, message: '请输入身份证号', trigger: 'blur'},
      {min: 15, max: 18, message: '请如实填写18位身份证号码', trigger: 'blur'},
      {validator: validateCode, message: '请输入正确的身份证号码', trigger: 'blur'},
    ],
    registerMobile: [
      {required: true, message: "请输入手机号码", trigger: "blur"},
      {validator: validateMobile, message: "请输入正确的手机号码", trigger: "blur"},
    ],
    // isPermanently: [
    //   { required: true, message: '请选择长期有效', trigger: 'change' }
    // ],
    // startValidity: [
    //   { required: true, message: "请输入有效期", trigger: "blur" },
    // ],
    // endValidity: [
    //   { required: true, message: "请输入有效期", trigger: "blur" },
    // ],
    contactAddress: [
      {required: true, message: "请输入身份证地址", trigger: "blur"},
      {validator: validateAddress, message: "请输入正确的身份证地址", trigger: "blur"},
    ]
  },
  // ---------------------关联代理商校验
  assocAgent: {
    agentId: [
      {required: true, message: "请选择代理商", trigger: "change"},
    ],
    agencyPoint: [
      {required: true, message: "请输入签约点数", trigger: "blur"},
    ],
    serviceFormula: [
      {required: true, message: "请选择服务费计算", trigger: "change"},
    ],
  },
  // ---------------------账户及余额校验
  balance: {
    bankAccountName: [
      {required: true, message: "请输入账户名称", trigger: "blur"}
    ]
  },
  // ---------------------人员管理校验
  customer: {
    name: [
      {required: true, message: "请输入姓名", trigger: "blur"},
      {min: 2, message: "姓名请输入 2-20 位", trigger: "blur"},
      {max: 20, message: "姓名请输入 2-20 位", trigger: "blur"},
      {validator: validateLegalMan, message: '姓名只能输入汉字', trigger: 'blur'}
    ],
    cardCode: [
      {required: true, message: "请输入身份证号", trigger: "blur"},
      {min: 15, max: 18, message: '请如实填写18位身份证号码', trigger: 'blur'},
      {validator: validateCode, message: '请输入正确的身份证号码', trigger: 'blur'},
    ],
    registerMobile: [
      {required: true, message: "请输入联系电话", trigger: "blur"},
      {validator: validatePhone, message: "请输入正确的电话号码", trigger: 'blur'},
    ],
    backupName: [
      {validator: validateEmail, message: "请输入正确的邮箱", trigger: "blur"}
    ]
  },
  // ---------------------开票记录校验
  bill: {
    expressName: [
      {max: 20, message: "姓名最长输入20个字符", trigger: "blur"},
      {validator: validateName, message: "姓名只能输入汉字", trigger: "blur"},
    ],
    expressPhone: [
      {validator: validateBillMobile, message: "请输入正确的手机号码", trigger: "blur"}
    ],
    expressEmail: [
      {validator: validateEmail, message: "请输入正确的邮箱", trigger: "blur"}
    ],
    expressAddress: [
      {validator: validateSiteCont, message: "收件人地址支持输入汉字、字母、数字、特殊字符", trigger: "blur"},
    ],
    expressNo: [
      {max: 20, message: "快递单号最长输入20个字符", trigger: "blur"},
      {validator: validateBillNum, message: "请输入正确的快递单号", trigger: "blur"},
    ],
    billNum: [
      {max: 50, message: "发票号最长输入50个字符", trigger: "blur"},
      {validator: validateBillNum, message: "请输入正确的发票号", trigger: "blur"},
    ],
    remarks: [
      {max: 200, message: "备注最长输入200个字符", trigger: "blur"},
      {validator: validateSiteCont, message: "备注支持输入汉字、字母、数字、特殊字符", trigger: "blur"},
    ],
  },
  // ---------------------税单查询
  history: {
    merchantId: [
      {required: true, message: "请选择商户名称", trigger: "change"},
    ],
    serviceId: [
      {required: true, message: "请选择服务商名称", trigger: "change"},
    ],
    billMonth: [
      {required: true, message: "请选择税单月份", trigger: "change"},
    ],
  },
  // ---------------------服务费明细（系统）
  detail: {
    amount: [
      {required: true, message: "请输入提现金额", trigger: "blur"},
    ],
    code: [
      {required: true, message: "请输入验证码", trigger: "blur"},
    ],
    merchantName: [
      {required: true, message: "请输入到账用户名", trigger: "blur"},
    ],
    accountNumber: [
      {required: true, message: "请输入到账支付宝", trigger: "blur"},
    ]
  },
  // ---------------------系统用户
  system: {
    personName: [
      {required: true, message: "请输入用户名", trigger: "blur"},
    ],
    userName: [
      {required: true, message: "请输入登录账号", trigger: "blur"},
      {required: true, message: "登录账号已存在！", trigger: "blur"},
    ],
  },
  // ---------------------商户支付分流设置/服务商支付分流设置
  aloneSet: {
    accountType: [
      {required: true, message: "请选择支付账户类型", trigger: "change"},
    ],
    paymentChannel: [
      {required: true, message: "请选择支付通道", trigger: "blur"},
    ],
    order: [
      {required: true, message: "请输入规则排序", trigger: "blur"},
    ],
  },
  // ---------------------平台设置
  platform: {
    name: [
      {required: true, message: "请输入名称", trigger: "blur"}
    ],
    fullName: [
      {required: true, message: "请输入全称", trigger: "blur"}
    ],
    contactName: [
      {required: true, message: "请输入联系人", trigger: "blur"},
      {min: 2, message: "联系人请输入 2-20 位", trigger: "blur"},
      {max: 20, message: "联系人请输入 2-20 位", trigger: "blur"},
      {validator: validateName, message: '联系人只能输入汉字', trigger: 'blur'}
    ],
    contactMobile: [
      {required: true, message: "请输入联系电话", trigger: "blur"},
      {required: true, validator: validateTelphone, trigger: "blur"},
    ],
    platNo: [
      {required: true, message: "请输入平台编号", trigger: "blur"},
      {required: true, pattern: '^(?!.*[Qq]).*$', message: "不支持使用Q或q", trigger: "blur"}
    ],
    domain: [
      {required: true, message: "请输入域名", trigger: "blur"}
    ],
  },
  // ---------------------任务审核记录
  quest: {
    taskName: [
      {required: true, message: "请输入任务名称", trigger: "blur"},
      {max: 100, message: "最长100个字符", trigger: "blur"},
      {validator: validateTaskName, message: "请输入正确的任务名称", trigger: "blur"}
    ],
    taskType: [
      {required: true, message: "请选择任务类型", trigger: "change"}
    ],
    actionTime: [
      {required: true, message: "请输入任务开始时间", trigger: "blur"}
    ],
    taskPrincipal: [
      {required: true, message: "请输入任务负责人", trigger: "blur"},
      {min: 2, message: "负责人请输入 2-20 位字符", trigger: "blur"},
      {max: 20, message: "负责人请输入 2-20 位字符", trigger: "blur"},
      {validator: validateLegalMan, message: "负责人只能输入汉字", trigger: "blur"}
    ],
    taskCycle: [
      {required: true, message: "请输入任务周期", trigger: "blur"},
      {max: 4, message: "任务周期最长只能输入4个字符", trigger: "blur"},
      {required: true, pattern: /^[0-9]*[1-9][0-9]*$/, message: "任务周期只能输入正整数", trigger: "blur"}
    ],
    taskBudget: [
      {required: true, message: "请输入任务预算", trigger: "blur"},
      {max: 8, message: "金额最长只能输入8个字符", trigger: "blur"},
      // {required: true, pattern: /^[0-9]*[1-9][0-9]*$/, message: "任务预算只能输入正整数", trigger: "blur"}
      {
        required: true,
        pattern: /^(?:[1-9][0-9]*(\.[0-9]+)?|0\.[0-9]+)$/,
        message: "任务预算只能输入正整数",
        trigger: "blur"
      }
    ],
    taskPrincipalPhone: [
      {required: true, message: "请输入联系电话", trigger: "blur"},
      {validator: validatePhone, message: "请输入正确的电话号码", trigger: "blur"}
    ],
    taskDesc: [
      {required: true, message: "请输入任务详情", trigger: "blur"},
      {validator: validateTaskDes, message: "任务详情不符合规则", trigger: "blur"}
    ]
  },
  // ---------------------上传合同
  contract: {
    merchant: [
      {required: true, message: "请选择商户名称", trigger: "change"},
    ],
    serviceIds: [
      {required: true, message: "请选择服务商名称", trigger: "change"},
    ],
    contractStartTime: [
      {required: true, message: "请选择签署日期", trigger: "blur"},
    ],
    contractEndTime: [
      {required: true, message: "请选择到期日期", trigger: "blur"},
    ],
    isDefault: [
      {required: true, message: "请选择是否默认", trigger: "change"},
    ],
    contractFile: [
      {required: true, message: "请上传合同附件", trigger: "change"},
    ]
  },

  // ---------------------新增任务示例
  taskExample: {
    industryName: [
      {required: true, message: "请选择行业分类", trigger: "change"},
    ],
    industryId: [
      {required: true, message: "请选择行业分类", trigger: "change"},
    ],
    sceneId: [
      {required: true, message: "请选择行业分类", trigger: "change"},
    ],
    taskName: [
      {required: true, message: "请输入任务名称", trigger: "blur"},
      {max: 20, message: "任务名称最长20个字符", trigger: "blur"},
    ],
    taskDetail: [
      {required: true, message: "请输入任务描述", trigger: "blur"},
      {max: 500, message: "任务描述最长500个字符", trigger: "blur"},
    ],
  },
}



// WEBPACK FOOTER //
// ./src/utils/formCheck.js